import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: 'designDetail',
components: {
XHeader,
CheckIcon,
Group,
XButton
},
data () {
return {
activeClass: 'wxPay',
num: 0
}
},
methods: {
getItme(payMethod) {
console.log(payMethod)
this.activeClass = payMethod;  
},
},
created () {

}
}



// WEBPACK FOOTER //
// ./src/views/designDetail/script.js